<div class="card mt-4">
  <h4 class="card-header card-title">{{ settings.title || 'Users' }}</h4>
  <div class="card-body">
    <div *ngIf="settings.subtitle">{{ settings.subtitle }}</div>
    <h2 *ngIf="count < 0" class="text-danger">Error</h2>
    <h2 *ngIf="count >= 0">{{ count }}</h2>
    <h2 *ngIf="count == null" class="spinner-border spinner-border-lg"></h2>
  </div>
</div>
